import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../core/session.service';
import { I18nService, SupportedLanguage } from '../../core/i18n.service';
import { ThemeService } from '../../core/theme.service';
import { ProfileMenu } from '../profile-menu/profile-menu';
import { FormsModule } from '@angular/forms';

@Component({ selector: 'app-navbar', standalone: true, imports: [RouterLink, RouterLinkActive, ProfileMenu, FormsModule], templateUrl: './navbar.html', styleUrl: './navbar.scss' })
export class Navbar {
  @ViewChild('mainNav') private mainNav?: ElementRef<HTMLElement>;
  env = environment;
  readonly versionBadgeLabel = `${environment.name.toUpperCase()} · v${environment.version || '1.2.0'}`;
  isMenuOpen = false;
  constructor(public session: SessionService, public i18n: I18nService, public theme: ThemeService, private router: Router) {}

  setLanguage(language: SupportedLanguage): void {
    void this.i18n.setLanguage(language);
  }

  toggleTheme(): void {
    this.theme.toggleTheme();
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    const collapseElement = this.mainNav?.nativeElement;
    if (!collapseElement?.classList.contains('show')) return;

    const bootstrapCollapse = (window as unknown as { bootstrap?: { Collapse?: { getOrCreateInstance(element: Element, options?: { toggle?: boolean }): { hide(): void } } } }).bootstrap?.Collapse;
    if (bootstrapCollapse) {
      bootstrapCollapse.getOrCreateInstance(collapseElement, { toggle: false }).hide();
      return;
    }

    collapseElement.classList.remove('show');
  }

  navigateAndClose(route: string): void {
    this.closeMenu();
    void this.router.navigate([route]);
  }
}
